import { Spinner, Table } from 'react-bootstrap';

import type { AlertLogRow } from '../../data-access/logs.api';
import { CHART_HEADINGS, EMPTY_MESSAGES } from '../constants';
import { alertSeverityClass, formatCostByProjectName, formatLogLabel } from '../formatters';
import MonitoringTablePagination from './MonitoringTablePagination';

type MonitoringApiLogTableProps = {
  rows: AlertLogRow[];
  page: number;
  totalPages: number;
  total: number;
  rangeStart: number;
  rangeEnd: number;
  busy: boolean;
  isInitialLoading: boolean;
  onPageChange: (page: number) => void;
  visiblePages: number[];
  hasPrevEllipsis: boolean;
  hasNextEllipsis: boolean;
};

const MonitoringApiLogTable = ({
  rows,
  page,
  totalPages,
  total,
  rangeStart,
  rangeEnd,
  busy,
  isInitialLoading,
  onPageChange,
  visiblePages,
  hasPrevEllipsis,
  hasNextEllipsis
}: MonitoringApiLogTableProps) => (
  <section className="realtime-monitoring-tab__section realtime-monitoring-tab__section--table">
    <h2 className="realtime-monitoring-tab__section-title">{CHART_HEADINGS.apiRequestLog}</h2>
    <div
      className={`realtime-monitoring-tab__table-wrap${busy ? ' realtime-monitoring-tab__table-wrap--loading' : ''}`}
    >
      {isInitialLoading ? (
        <div className="text-center py-5">
          <Spinner animation="border" size="sm" />
        </div>
      ) : (
        <Table responsive hover className="mb-0">
          <thead>
            <tr>
              <th>Time</th>
              <th>Project</th>
              <th>API</th>
              <th>Trigger</th>
              <th>Severity</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={5} className="p-0 border-0">
                  <div
                    className="d-flex align-items-center justify-content-center w-100 realtime-monitoring-tab__empty-state"
                    style={{ height: 160, padding: '0 20px', textAlign: 'center' }}
                    role="status"
                  >
                    {EMPTY_MESSAGES.apiTable}
                  </div>
                </td>
              </tr>
            ) : (
              rows.map(row => (
                <tr key={row.id}>
                  <td>{row.time}</td>
                  <td>{formatCostByProjectName(row.project_name)}</td>
                  <td>{formatLogLabel(row.api_name)}</td>
                  <td>{row.trigger}</td>
                  <td>
                    <span className={alertSeverityClass(row.severity)}>{row.severity}</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </div>
    <MonitoringTablePagination
      page={page}
      totalPages={totalPages}
      total={total}
      rangeStart={rangeStart}
      rangeEnd={rangeEnd}
      itemLabel="API requests"
      busy={busy}
      onPageChange={onPageChange}
      visiblePages={visiblePages}
      hasPrevEllipsis={hasPrevEllipsis}
      hasNextEllipsis={hasNextEllipsis}
    />
  </section>
);

export default MonitoringApiLogTable;
